import { render } from "./TheNavbar.vue?vue&type=template&id=19a97aa8"
const script = {}
script.render = render

export default script